<script setup>
import { useScheduleFilterMobileState } from '@/schedule/composables/useScheduleFilterMobileState'

const show = useScheduleFilterMobileState()
</script>

<template>
  <DSOffcanvas
    :show="show"
    @close="show = false"
  >
    <slot />
  </DSOffcanvas>
</template>
